$(document).ready(function () {
  "use strict";

  $(".order--container").on("click", function () {
    if ($(this).hasClass("follow__link") == false) {
      var orderId = $(this).attr("order-id");
      $('.order__details[order-id="' + orderId + '"]')
        .slideToggle(200)
        .toggleClass("is-active");
      $(this).toggleClass("child-active");
      $(this)
        .children(".open__line__items--link")
        .children()
        .toggleClass("arrow--top arrow--bottom");
    }
  });

  $("#reset-password").click(function () {
    $("#connexion").css("display", "none");
    $("#reset").fadeIn("slow");
  });
  ("use strict");

  $("#accordion-navigation .plus__icon").show();
  $("#accordion-navigation")
    .find("li.extend")
    .click(function (e) {
      $(this).children(".extended-submenu").slideToggle("fast");
      $(this)
        .children(".nav--title")
        .children(".plus__icon")
        .toggleClass("opened");
      $(this).toggleClass("active");
    });
  ("use strict");

  // Si le client veut la formule RGPD
  // --> on supprime ce qui est non commente
  // --> on decommente le reste

  $(".button--cookie").click(function () {
    $("#cookie--banner").hide();
    $("#page__overlay--cookie").removeClass("opened");
  });

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  if (getCookie("cookies-accepted") == "yes") {
  } else {
    $("#cookie--banner").addClass("apparition--cookie");
    $("#page__overlay--cookie").addClass("opened");
  }

  $("#accept--all, #reject--all").on("click", function () {
    var CookieDate = new Date();
    CookieDate.setMonth(CookieDate.getMonth() + 12);
    document.cookie =
      "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
  });

  // window.Shopify.loadFeatures([
  //   {
  //     name: 'consent-tracking-api',
  //     version: '0.1',
  //   },
  // ], function (error) {
  //   if (error) {
  //     throw error;
  //   }
  //   const showBanner = window.Shopify.customerPrivacy.shouldShowGDPRBanner();

  //   if (showBanner == true) {
  //     setTimeout(function(){
  //       $("#cookie--banner").addClass( "apparition--cookie" );
  //       $('#page__overlay--cookie').addClass("opened");
  //     }, 1000);
  //   } else {
  //     if (window.Shopify.customerPrivacy.userCanBeTracked()) {
  //       document.dispatchEvent(new CustomEvent('trackingConsentAccepted'));
  //     }
  //   }
  // });

  // $('#accept--all').on('click', function() {
  //   window.Shopify.customerPrivacy.setTrackingConsent(true, function() {
  //     $("#cookie--banner").hide();
  //     $('#page__overlay--cookie').removeClass("opened");
  //   });
  // })

  // $('#reject--all').on('click', function() {
  //   window.Shopify.customerPrivacy.setTrackingConsent(false, function() {
  //     $("#cookie--banner").hide();
  //     $('#page__overlay--cookie').removeClass("opened");
  //   });
  // })

  // document.addEventListener('trackingConsentAccepted', function (e) {
  //   console.log('tracking accepted')
  // }, false);
  ("use strict");

  if (window.collection) {
    var selectedInput = $(
      '.select__custom--value[value="' + window.collection.defaultSortBy + '"]',
    )
      .first()
      .text();

    $(
      '.select__custom--value[value="' + window.collection.defaultSortBy + '"]',
    ).addClass("is__active");

    if (window.matchMedia("(min-width: 768px)").matches) {
      $(".select__custom--selected-value").text(selectedInput);
    }
  }
  ("use strict");

  if (window.location.href.indexOf("collection") > -1) {
    var printUrl = function printUrl(list) {
      var filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?";
      for (var filter in list) {
        filteredUrl += list[filter].type + "=" + list[filter].value + "&";
      }

      var sortBy = $(
        "#sort__by--container .select__custom--value.is__active",
      ).attr("value");
      var filterSortBy = "sort_by=" + sortBy;

      var pageUrl = "";
      if (window.location.href.indexOf("page=") > -1) {
        var url_string = window.location.href;
        var url = new URL(url_string);
        var numberPage = url.searchParams.get("page");
        pageUrl = "&page=" + numberPage;
      }

      var finalUrl = filteredUrl + filterSortBy + pageUrl;

      if (history.replaceState) {
        window.history.replaceState({ path: finalUrl }, "", finalUrl);
      }

      $.ajax({
        type: "GET",
        url: finalUrl + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));

          clearFilter();
        },
        error: function error(_error2) {
          console.log("erreur");
        },
      });
    };

    // Filters
    $("body").on("click", ".reinitialize__filters", function () {
      window.collection.currentFilters = [];
      $(".reinitialize__filters").hide();
      $(".filter__item--mini").remove();
      $(".filter__button").removeClass("is__active");
      var filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?sort_by=" +
        window.collection.sortBy;
      if (history.replaceState) {
        window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
      }
      $.ajax({
        type: "GET",
        url: filteredUrl + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));
        },
        error: function error(_error) {
          console.log("erreur");
        },
      });
    });

    $("body").on("click", ".filter__item--mini", function () {
      var filter_value = $(this).attr("filter-value-handle");
      $(
        ".filter__item--mini[filter-value-handle=" + filter_value + "]",
      ).remove();
      $(".filter__button[filter-value-handle=" + filter_value + "]")[0].click();
    });

    var collectionFilter = {};
    if ($("[collection-filter]").html()) {
      collectionFilter = JSON.parse($("[collection-filter]").html());
    }

    /*//Range slider price
  var $range = $(".js-range-slider"),
      $from = $(".from"),
      $to = $(".to"),
      range,
      min = $range.data('min'),
      max = $range.data('max'),
      from,
      to;

  var updateValues = function () {
    $from.prop("value", from);
    $to.prop("value", to);

    dataFilter = boucleFilter()
    console.log(dataFilter)
    printUrl(dataFilter)

  };*/

    var updateFilter = function updateFilter() {
      var maxRange = collectionFilter.filterMaxRange / 100;
      if (from == "0" && to == maxRange) {
        $('.active-filters__remove-filter[filtername="filter-price"]').hide();
      } else {
        $('.active-filters__remove-filter[filtername="filter-price"]').show();
        $(".min-value-filter").text(from + "€");
        $(".max-value-filter").text(to + "€");
      }
    };

    /*$range.ionRangeSlider({
    onChange: function (data) {
      from = data.from;
      to = data.to;
      updateValues();
      updateFilter()
    }
  });

  range = $range.data("ionRangeSlider");
  var updateRange = function () {
    range.update({
      from: from,
      to: to
    });
  };


  $from.on("input", function () {
    from = +$(this).prop("value");
    if (from < min) {
      from = min;
    }
    if (from > to) {
      from = to;
    }
    updateValues();
    updateRange();
    updateFilter()
  });

  $to.on("input", function () {
    to = +$(this).prop("value")
    if (to > max) {
      to = max;
    }
    if (to < from) {
      to = from;
    }
    updateValues();
    updateRange();
    updateFilter()
  });

  $(document).ready(function(){
    if (collectionFilter.filterMaxValue != ''){
      to = (collectionFilter.filterMaxValue) / 100
    }
    if (collectionFilter.filterMinValue != ''){
      from = (collectionFilter.filterMinValue) / 100
    }
    //updateValues();
    updateRange();
  })*/

    var clearFilter = function clearFilter() {
      var url = window.location.href;
      var matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
      var count = matches ? matches.length : 0;
      if (window.location.search.indexOf("page=") > -1) {
        count = count - 1;
      }
      /*if(count > 1 ){
      $('.active-filters__clear').show()
    } else {
      $('.active-filters__clear').hide()
    }*/
    };

    $(document).ready(function () {
      clearFilter();
    });

    var dataFilter = [];

    var boucleFilter = function boucleFilter() {
      var array = [];
      $(".filter-group-display__list").each(function () {
        var containerFilter = $(this).children(
          ".filter-group-display__list-item",
        );

        var checkbox = containerFilter
          .children(".filter--container")
          .children(".checkbox-filter--container");
        var value = "";
        var name = checkbox.attr("name");
        var compteurCheck = 0;
        for (var i = 1; i <= containerFilter.length; i++) {
          var loopCheckbox = containerFilter
            .children(".filter--container")
            .children(".checkbox-" + i);

          if (loopCheckbox.hasClass("checked")) {
            if (name == "filter.v.option.taille") {
              array.push({ type: "filter.v.availability", value: 1 });
            }

            compteurCheck += 1;

            compteurCheck == 1
              ? (value = loopCheckbox.attr("value"))
              : (value = value + "," + loopCheckbox.attr("value"));
          }
        }

        compteurCheck > 0 ? array.push({ type: name, value: value }) : null;
      });

      var nameFilterLow = $("#lowPriceFilter").attr("name");
      var valueLow = $("#lowPriceFilter").val();

      var nameFilterHigh = $("#highPriceFilter").attr("name");
      var valueHigh = $("#highPriceFilter").val();
      var maxValueHigh = $("#highPriceFilter").attr("max");

      if (parseInt(valueLow) > 0) {
        array.push({ type: nameFilterLow, value: valueLow });
      }

      if (parseInt(valueHigh) <= parseInt(maxValueHigh)) {
        array.push({ type: nameFilterHigh, value: valueHigh });
      }

      return array;
    };

    if (window.location.href.indexOf("collections") > -1) {
      dataFilter = boucleFilter();
    }

    $("body").on("click", ".filter--container", function () {
      var filterTaille = $(this)
        .find(".checkbox-filter--container")
        .attr("name");
      if ($(this).find(".checkbox-filter--container").hasClass("checked")) {
        var filterName = $(this)
          .find(".checkbox-filter--container")
          .attr("filtername");
        //$(`.active-filters__remove-filter[filtername=${filterName}]`).remove()
        if (filterTaille == "filter.v.option.taille") {
        }
        //$(this).removeClass('checked')
      } else {
        //$(this).addClass('checked')
        var filterName = $(this)
          .find(".checkbox-filter--container")
          .attr("filtername");
        if (filterName == "Disponibilité-Enstock") {
          var filterValue = "En stock";
        } else if (filterTaille == "filter.v.option.taille") {
          console.log("Taille click");
          $(".taille--container").removeClass("checked");
          $(".taille--container")
            .children(".checkbox-filter--container")
            .removeClass("checked");
        } else {
          var filterValue = $(this)
            .find(".checkbox-filter--container")
            .attr("value");
        }
        $(".active-filters").append(
          '\n    <a class="active-filters__remove-filter cursor--pointer" filtername="' +
            filterName +
            '">\n        ' +
            filterValue +
            " X\n    </a>\n  ",
        );
      }

      var checkboxContainer = $(this).children(".checkbox-filter--container");
      checkboxContainer.hasClass("checked")
        ? checkboxContainer.removeClass("checked")
        : checkboxContainer.addClass("checked");
      $(this).hasClass("checked")
        ? $(this).removeClass("checked")
        : $(this).addClass("checked");

      dataFilter = boucleFilter();

      console.log(dataFilter);
      printUrl(dataFilter);
    });

    $("body").on("click", ".active-filters__remove-filter", function () {
      var filterName = $(this).attr("filtername");
      if (filterName == "filter-price") {
        $('.active-filters__remove-filter[filtername="filter-price"]').hide();
        $("#lowPriceFilter").attr("value", 0);
        var maxRangeValue = collectionFilter.filterMaxRange / 100;

        $("#highPriceFilter").attr("value", maxRangeValue);
        $("#highPriceFilter").val(maxRangeValue);
        to = maxRangeValue;
        from = 0;
        updateValues();
        updateRange();
      } else {
        $(this).remove();
        $(
          ".checkbox-filter--container[filtername=" + filterName + "]",
        ).removeClass("checked");
      }
      dataFilter = boucleFilter();
      printUrl(dataFilter);
    });

    /*$('body').on('click', '.filter-group-summary', function() {
    if ($(this).hasClass('checked')){
      $(this).removeClass('checked')
      $(this).siblings('.filter-group-display').slideToggle(200)
      $(this).children('.icon--arrow-bottom').removeClass('opened')
    } else {
      $(this).addClass('checked')
      $(this).siblings('.filter-group-display').slideToggle(200)
      $(this).children('.icon--arrow-bottom').addClass('opened')
    }

  })*/

    $("body").on("click", ".filter__button", function () {
      var mini__filter = window.collection.miniFilter;
      var filter_value = $(this).attr("filter-value-handle"),
        filteredUrl = "";
      var filtersList = window.collection.currentFilters;

      if ($(this).hasClass("is__active")) {
        $(
          ".filter__button[filter-value-handle=" + filter_value + "]",
        ).removeClass("is__active");

        filtersList.splice(filtersList.indexOf(filter_value), 1);

        window.collection.currentFilters = filtersList;
        window.collection.currentFilters.sort();

        $(
          ".filter__item--mini[filter-value-handle=" + filter_value + "]",
        ).remove();
      } else {
        // Supprime les tags du meme groupe deja actifs
        var group = filter_value.split("_")[0];
        $('.filter__button[filter-group-handle="' + group + '"]').removeClass(
          "is__active",
        );
        $('.filter__item--mini[filter-group-handle="' + group + '"]').remove();
        $(".filter__button[filter-value-handle=" + filter_value + "]").addClass(
          "is__active",
        );
        for (var i = 0; i < filtersList.length; i++) {
          if (filtersList[i].indexOf(group) > -1) {
            filtersList.splice(i, 1);
          }
        }

        window.collection.currentFilters = filtersList;
        window.collection.currentFilters.push(filter_value);
        window.collection.currentFilters.sort();

        $(".filter__values--list").append(
          '<li class="filter__item--mini body--text--footer" filter-value-handle="' +
            filter_value +
            '" filter-group-handle="' +
            group +
            '"><span>' +
            $(this).attr("filter-group") +
            ": " +
            $(this).attr("filter-value") +
            '</span><span class="close close__filter"></span></li>',
        );
      }

      if (window.collection.currentFilters.length > 0) {
        $(".reinitialize__filters").show();
        filteredUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.collection.collectionUrl +
          "/" +
          window.collection.currentFilters.join("+") +
          "?sort_by=" +
          window.collection.sortBy;
      } else {
        $(".reinitialize__filters").hide();
        filteredUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.collection.collectionUrl +
          "?sort_by=" +
          window.collection.sortBy;
      }

      if (history.replaceState) {
        window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
      }

      $.ajax({
        type: "GET",
        url: filteredUrl + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));
        },
        error: function error(_error3) {
          console.log("erreur");
        },
      });
    });

    // mobile
    $(".action--button-validate").on("click", function (e) {
      e.preventDefault();
      $("#navigation__drawer--header .close").click();
    });
    $(".action--button-close").on("click", function (e) {
      e.preventDefault();
      $("#navigation__drawer--header .close").click();
    });

    $(".filter__group--title").on("click", function () {
      $(this).children("plus__icon").toggleClass("opened");
      $(this).siblings(".filter__group--item-list").slideToggle(300);
      $(this).toggleClass("opened");
    });
  }
  ("use strict");

  /*$('.product__item__link--container').on('click', function(e) {
  e.preventDefault();
  if ($(e.target).is('.property--item')) {
    var url = $(e.target).attr('link');
    window.location.href = url;
  } else {
    window.location = this.href;
  }
})*/

  $("body").on("click", ".choice-taille", function () {
    $(
      ".title-taille--container, .icon--arrow-bottom, .choice-taille--container",
    ).removeClass("opened");

    var variantId = $(this).attr("variant-id");
    var variantAvailable = $(this).attr("variant-available");
    var variantTitle = $(this).text();
    var productId = $(this).attr("product-id");

    var buttonGrid = $(".button-add-grid[product-id=" + productId + "]");
    buttonGrid.attr("variant-id", variantId);
    buttonGrid.attr("variant-available", variantAvailable);
    if ($(this).hasClass("choice-taille-reco")) {
      var productPrice = $(this).attr("product-price");
      variantAvailable == "false"
        ? buttonGrid.text(window.general.soldOutOneWord)
        : buttonGrid.text(
            window.general.addToCartOneWord + " - " + productPrice,
          );
    } else {
      variantAvailable == "false"
        ? buttonGrid.text(window.general.soldOutOneWord)
        : buttonGrid.text(window.general.addToCartOneWord);
    }
    $(".taille-title[product-id=" + productId + "]").text(variantTitle);
  });

  $("body").on("click", ".title-taille--container", function () {
    if ($(this).hasClass("opened")) {
      $(this).removeClass("opened");
      $(this).children(".icon--arrow-bottom").removeClass("opened");
      $(this).siblings(".choice-taille--container").removeClass("opened");
    } else {
      $(this).addClass("opened");
      $(this).children(".icon--arrow-bottom").addClass("opened");
      $(this).siblings(".choice-taille--container").addClass("opened");
    }
  });

  $("body").on("mouseleave", ".product__item--container", function (e) {
    $(
      ".title-taille--container, .icon--arrow-bottom, .choice-taille--container",
    ).removeClass("opened");
  });

  $("body").on("mouseleave", ".hover-reco-lateral", function (e) {
    $(
      ".title-taille--container, .icon--arrow-bottom, .choice-taille--container",
    ).removeClass("opened");
  });
  ("use strict");

  document.addEventListener(
    "cart:open",
    function (elem) {
      if (window.cart.cartType == "preview") {
        $("#cart__preview").addClass("opened--added-to-cart");
        $(".link--text-style--cart").addClass("link__active");

        if (window.matchMedia("(max-width: 1100px)").matches) {
          $("#page__overlay--navigation").addClass("opened");
        } else {
          setTimeout(function () {
            $("#cart__preview").removeClass("opened--added-to-cart");
            if ($("#cart__preview").hasClass("opened") == false) {
              $(".link--text-style--cart").removeClass("link__active");
            }
          }, 4000);
        }
      } else {
        $("#cart__drawer").addClass("opened");
        $("#page__overlay").addClass("opened");
        $("#page__overlay").attr("for", "drawer");
        setTimeout(function () {
          $("#drawer__cart--exta-infos").addClass("opened");
        }, 350);
      }
    },
    false,
  );

  var updateDeliveryModule = function updateDeliveryModule(total) {
    if (window.cart.deliveryModule) {
      var deliveryLimit = window.cart.freeDelivery - 1;
      var remainPercentage = Math.max(
        0,
        ((deliveryLimit - total) / deliveryLimit) * 100,
      );
      var remainMoney = Math.max(0, (deliveryLimit + 1 - total) / 100);
      var colorBar = 100 - remainPercentage;

      $("#progress__bar--remain").css("width", colorBar + "%");

      if (remainMoney > 0) {
        $("#free__shipping--message").hide();
        $("#remain__shipping__amount--message").show();
        $(".amount__remaining").text(remainMoney + "€");
      } else {
        $("#free__shipping--message").show();
        $("#remain__shipping__amount--message").hide();
      }
    }
  };
  ("use strict");

  if (window.matchMedia("(min-width: 1101px)").matches) {
    $(".button__action--cart-preview").mouseenter(function (e) {
      $("#cart__preview").addClass("opened");
      //handleNavbarHover("opened");
    });

    $("#cart__preview").mouseenter(function (e) {
      $("#cart__preview").addClass("opened");
      handleNavbarHover("opened");
    });

    $("#cart__preview").mouseleave(function (e) {
      $("#cart__preview").removeClass("opened");
      $("#cart__preview").removeClass("opened--added-to-cart");

      $(".link--text-style--cart").removeClass("link__active");
      if ($(e.relatedTarget).is(".link--text-style")) {
      } else {
        //handleNavbarHover("closed");
      }
    });

    $(".button__action--cart-preview").mouseleave(function (e) {
      $("#cart__preview").removeClass("opened");
      $("#cart__preview").removeClass("opened--added-to-cart");

      $(".link--text-style--cart").removeClass("link__active");
      if (
        $(e.relatedTarget).is(
          ".links__container--half, #navigation__links--list, .link--text-style, .announcement__bar--container",
        )
      ) {
      } else {
        handleNavbarHover("closed");
      }
    });
  } else {
    $(".button__action--cart-preview").on("click", function () {
      if ($("#cart__preview").hasClass("opened")) {
        $("#cart__preview").removeClass("opened");
        $("#cart__preview").removeClass("opened--added-to-cart");
        $("#page__overlay--navigation").removeClass("opened");
        handleNavbarHover("closed");
      } else {
        $("#cart__preview").addClass("opened");
        $("#page__overlay--navigation").addClass("opened");
        handleNavbarHover("opened");
      }
    });

    $(".close--cart-preview").on("click", function () {
      $("#cart__preview").removeClass("opened opened--added-to-cart");
      $("#cart__preview").removeClass("opened--added-to-cart");
      $("#page__overlay--navigation").removeClass("opened");
      handleNavbarHover("closed");
    });

    $("body").on("click", "#page__overlay--navigation", function () {
      $("#cart__preview").removeClass("opened opened--added-to-cart");
      $("#cart__preview").removeClass("opened--added-to-cart");
      $("#page__overlay--navigation").removeClass("opened");
      handleNavbarHover("closed");
    });
  }

  if ($(document).scrollTop() > 20) {
    $("#cart__preview").css("top", "48px");
  }

  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      $("#cart__preview").css("top", "48px");
    } else {
      $("#cart__preview").css("top", "85px");
    }
  });

  // function handleNavbarHover(status) {
  //   if (window.location.pathname == "/") {
  //     if (window.matchMedia("(min-width: 1101px)").matches) {
  //       if (status == "opened") {
  //         $(".link--text-style--cart").addClass("link__active");
  //         $("#navigation--container").removeClass("transparent--nav");
  //         $("#main__logo--svg").removeClass("logo--white");
  //       } else {
  //         $("#navigation--container").addClass("transparent--nav");
  //         $("#main__logo--svg").addClass("logo--white");
  //       }
  //     }
  //   }
  // }
  ("use strict");

  // Add to cart funnction
  if (window.location.pathname == "/cart") {
    window.cart.drawer = false;
  }

  $("body").on("click", ".add__to__cart", function (e) {
    e.preventDefault();
    var variantId = $(this).attr("variant-id");
    var available = $(this).attr("variant-available");
    var productHandle = $(this).attr("product-handle");
    var variants = $(this).attr("variants");
    var type = $(this).attr("button-type");
    var $this = $(this);

    //$this.children('.button--text').css('display', 'none');
    //$this.children('.button--loading').css('display', 'block');

    if (available == "true" || available == true) {
      if (variantId) {
        var qty = 1;
        if (type == "product") {
          qty = $(".product__qty--container .quantity__current").val();
        }
        var objUpdate = { quantity: qty, id: variantId };
        console.log(objUpdate);
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: objUpdate,
          dataType: "json",
          success: function success(response) {
            updateCartData();
            document.dispatchEvent(new CustomEvent("update-reco-drawer"));

            if ($("#empty__cart--title").length > 0) {
              location.reload(true);
            }

            document.dispatchEvent(new CustomEvent("cart:open"));
            $this.children(".button--text").css("display", "block");
            $this.children(".button--loading").css("display", "none");
          },
          error: function error(_error) {
            console.log("erreur");
            console.log(_error);
          },
        });
      }
    }
  });

  $("body").on("click", ".add__to__cart--grid-item", function (e) {
    e.preventDefault();
    var $this = $(this);
    var variant_id = $this.attr("product-variant");
    var qty = 1;
    var objUpdate = { quantity: qty, id: variant_id };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: objUpdate,
      dataType: "json",
      success: function success(response) {
        updateCartData();
        document.dispatchEvent(new CustomEvent("update-reco-drawer"));

        setTimeout(function () {
          $this.children(".button--loading").css("display", "none");
          $this.children(".button--text").show();
        }, 300);

        if (window.matchMedia("(max-width: 767px)").matches) {
          setTimeout(function () {
            $("#drawer__cart--exta-infos").removeClass("opened");
          }, 500);
        }
      },
      error: function error(_error2) {
        console.log("erreur");
        console.log(_error2);
      },
    });
  });

  $("body").on("change", ".qty--input", function (e) {
    e.preventDefault();
    var $this = $(this);
    var variantId = $(this).attr("variant-id");
    var variantQty = $this.val();

    if (variantId) {
      var data = { updates: {} };
      data.updates[variantId] = variantQty;

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: data,
        dataType: "json",
        success: function success(response) {
          // On render le cart via le module shippinh-module-cart.js
          updateCartData();
        },
        error: function error(_error3) {
          console.log("erreur");
        },
      });
    }
  });

  $("body").on("click", ".quantity__change--selector", function (e) {
    e.preventDefault();
    var $this = $(this);
    var variantId = $(this).attr("variant-id");
    var variantQty = $(this).attr("variant-qty");

    if (variantId) {
      var data = { updates: {} };
      data.updates[variantId] = variantQty;

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: data,
        dataType: "json",
        success: function success(response) {
          $('.quantity__current[variant-id="' + variantId + '"]').val(
            variantQty,
          );
          $(
            '.quantity__change--selector[type="minus"][variant-id="' +
              variantId +
              '"]',
          ).attr("variant-qty", parseInt(variantQty) - 1);
          $(
            '.quantity__change--selector[type="plus"][variant-id="' +
              variantId +
              '"]',
          ).attr("variant-qty", parseInt(variantQty) + 1);
          updateCartData();

          if (window.cart && window.cart.drawer) {
            document.dispatchEvent(new CustomEvent("cart:open"));
          }
        },
        error: function error(_error4) {
          console.log("erreur");
        },
      });
    }
  });

  $("body").on("click", ".remove--line-item", function (e) {
    e.preventDefault();
    var $this = $(this);
    var key = $(this).attr("key");

    var data = { updates: {} };
    data.updates[key] = 0;
    setTimeout(function () {
      $('.cart__item--container[key="' + key + '"]').remove();
    }, 300);
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function success(response) {
        updateCartData();
        document.dispatchEvent(new CustomEvent("update-reco-drawer"));
      },
      error: function error(_error5) {
        console.log("erreur");
      },
    });
  });

  var renderCart = function renderCart() {
    var url = "/cart?view=sidecart&timestamp=" + Date.now();

    if (window.general.langue !== "fr") {
      url =
        "/" +
        window.general.langue +
        "/cart?view=sidecart&timestamp=" +
        Date.now();
    }

    if (window.location.pathname == "/cart" > -1) {
      url = "/cart?view=page&timestamp=" + Date.now();
    }

    $.ajax({
      type: "GET",
      url: url,
      success: function success(content) {
        var newCart = content;
        $(".cart__items__and__header--container").remove();
        $(".cart--body").append(newCart);
      },
      error: function error(_error6) {
        console.log("erreur");
      },
    });
  };

  if (window.cart && window.cart.drawer == true) {
    renderCart();
  }

  var updateCartData = function updateCartData() {
    console.log("passe update");
    var url = "/cart";
    if (window.general.langue !== "fr") {
      url = "/" + window.general.langue + "/cart";
    }
    $.ajax({
      type: "GET",
      url: url,
      dataType: "json",
      success: function success(response) {
        var total = response.total_price;
        var empty = response.item_count == 0 ? true : false;
        updateDeliveryModule(total);
        renderCart();
        if (empty) {
          $(".cart--body").addClass("empty__cart");
          $(".subtotal--container").addClass("display__none");
          $(".empty__cart--drawer").removeClass("display__none");
          $(".items--count").text(0);

          if ($("#full__cart--title").length > 0) {
            location.reload(true);
          }
        } else {
          $(".cart--body").removeClass("empty__cart");
          $(".empty__cart--drawer").addClass("display__none");
          $(".subtotal--container").removeClass("display__none");
          $(".cart__total--drawer").text(displayPrice(total));

          $(".items--count").text(response.item_count);

          $(".cart__item--total-price").text(displayPrice(total));
          response.items.forEach(function (line_item) {
            var variantId = line_item.variant_id;
            $(
              ".cart__item--container[variant-id=" +
                variantId +
                "] .cart__item--total-price",
            ).text(displayPrice(line_item.line_price));
          });
        }
      },
      error: function error(_error7) {
        console.log("erreur");
      },
    });
  };

  $("#checkout--button").on("click", function (e) {
    document.location.href = "/checkout";
  });

  // Gestion du theme editor
  document.addEventListener(
    "update-bar",
    function (e) {
      updateCartData();
    },
    false,
  );

  $("#packaging__ecolo--container").on("click", function (e) {
    var CookieDate = new Date();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).children(".checkbox-ecolo").removeClass("active");

      CookieDate.setMonth(CookieDate.getMonth());
      document.cookie =
        "ecolo=yes; expires=" + CookieDate.toGMTString() + "; path=/";

      var objUpdate = {
        attributes: {
          "packaging-ecolo": "false",
        },
      };
    } else {
      $(this).addClass("active");
      $(this).children(".checkbox-ecolo").addClass("active");

      CookieDate.setMonth(CookieDate.getMonth() + 12);
      document.cookie =
        "ecolo=yes; expires=" + CookieDate.toGMTString() + "; path=/";

      var objUpdate = {
        attributes: {
          "packaging-ecolo": "true",
        },
      };
    }

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: objUpdate,
      dataType: "json",
      success: function success(response) {
        renderCart();
      },
      error: function error(_error8) {
        console.log(_error8);
      },
    });
  });

  if (getCookie("ecolo") == "yes") {
    $("#packaging__ecolo--container").addClass("active");
    $("#packaging__ecolo--container")
      .children(".checkbox-ecolo")
      .addClass("active");
  }
  ("use strict");

  if (window.cart) {
    var deliveryModuleWidth = 100;
    var renderFirst = 0;

    var nbSteps = window.cart.nbSteps;
    if (nbSteps > 1 && nbSteps < 3) {
      deliveryModuleWidth = 33.33;
    } else if (nbSteps > 2) {
      deliveryModuleWidth = 25;
    }
    var ajaxCartProducts = function ajaxCartProducts(qty1, qty2) {
      var objUpdate = { updates: {} };
      objUpdate.updates[39372618596457] = qty1;
      objUpdate.updates[39372619382889] = qty2;

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: objUpdate,
        dataType: "json",
        success: function success(response) {
          renderCart();
        },
        error: function error(_error) {
          console.log(_error);
        },
      });
    };

    var shippingBarLogic = function shippingBarLogic(total) {
      var currentStep = 1;
      if (total >= window.cart.steps[0] && total < window.cart.steps[1]) {
        currentStep = 2;
      } else if (total >= window.cart.steps[1]) {
        currentStep = 3;
      }

      var remainMoney = 0;
      var remainPercentage = 0;
      var colorBar = 0;

      var barCalculus = function barCalculus(step, total) {
        var seuilSuivant = window.cart.steps[step - 1];
        var seuilPrecedent = 0;
        if (step != 1) {
          seuilPrecedent = window.cart.steps[step - 2];
        }

        remainMoney = Math.max(0, (seuilSuivant - total) / 100);
        remainPercentage = Math.max(
          0,
          (seuilSuivant - total) / (seuilSuivant - seuilPrecedent),
        );
        colorBar =
          deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
      };

      var finalStep = function finalStep() {
        remainMoney = 0;
        remainPercentage = 0;
        colorBar = 100;
      };

      switch (currentStep) {
        case 1:
          barCalculus(1, total);
          break;
        case 2:
          barCalculus(2, total);
          break;
        case 3:
          barCalculus(3, total);
          break;
        default:
          break;
      }

      if (currentStep == 1) {
        //ajaxCartProducts(0,0);
      } else if (currentStep == 2 && nbSteps > 1) {
        if (nbSteps == 1) {
          finalStep();
        } else {
          if (window.cart.deliveryStep == 1) {
            //ajaxCartProducts(0,0);
          } else {
            //ajaxCartProducts(1,0);
          }
        }
      } else {
        finalStep();
        if (window.cart.deliveryStep == 0 && nbSteps == 2) {
          //ajaxCartProducts(1,1);
        } else if (window.cart.deliveryStep == 0 && nbSteps == 1) {
          //ajaxCartProducts(1,0);
        } else if (
          (window.cart.deliveryStep == 1 || window.cart.deliveryStep == 2) &&
          nbSteps == 2
        ) {
          //ajaxCartProducts(1,0);
        } else {
          //ajaxCartProducts(0,0);
        }
      }

      $("#progress__bar--remain").css("width", colorBar + "%");

      if (remainMoney > 0) {
        var moinsDix = remainMoney < 10 ? true : false;
        remainMoney = remainMoney.toString().replace(".", ",");
        if (moinsDix == true && remainMoney.length == 3) {
          remainMoney = remainMoney + "0";
        } else if (moinsDix == false && remainMoney.length == 4) {
          remainMoney = remainMoney + "0";
        }

        $("#free__shipping--message").hide();
        $("#remain__shipping__amount--message").show();
        $("#amount__remaining").text(remainMoney + "€");
        $(".free-delivery").hide();
      } else {
        $("#free__shipping--message").show();
        $("#remain__shipping__amount--message").hide();
        $(".free-delivery").show();
      }
    };

    var getCartTotal = function getCartTotal(callback, cart) {
      if (cart) {
        if (callback) {
          callback(cart.total_price);
        } else {
          return cart.total_price;
        }
      } else {
        $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
          success: function success(cart) {
            if (callback) {
              callback(cart.total_price);
            } else {
              return cart.total_price;
            }
          },
        });
      }
    };

    var initializeDeliveryModule = function initializeDeliveryModule() {
      var total = getCartTotal(shippingBarLogic);
    };

    setTimeout(function () {
      initializeDeliveryModule();
    }, 1000);

    var updateDeliveryModule = function updateDeliveryModule(total) {
      if (window.cart.deliveryModule) {
        if (total) {
          shippingBarLogic(total);
        } else {
          getCartTotal(shippingBarLogic);
        }
      }
    };
  }
  ("use strict");

  var emballageCadeauVariantId = window.giftBoxvariant;
  $(".emballage__cadeau--button").on("click", function () {
    var data = { updates: {} };
    data.updates[emballageCadeauVariantId] = 1;
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function success() {
        location.reload();
      },
    });
  });
  ("use strict");

  document.addEventListener(
    "update-reco-drawer",
    function (e) {
      var url =
        "https://" + window.location.hostname + "/?section_id=reco-lateral";
      if (window.general.langue !== "fr") {
        url =
          "https://" +
          window.location.hostname +
          "/" +
          window.general.langue +
          "/?section_id=reco-lateral";
      }
      $.ajax({
        type: "GET",
        url: url,
        success: function success(data) {
          $("#product-reco--container").empty().append(data);
        },
        error: function error(_error) {
          console.log("erreur");
          console.log(_error);
        },
      });
    },
    false,
  );

  $("body").on("click", ".reco--aded-to-cart", function (e) {
    var handle = $(this).attr("product-handle");
    if (typeof ga === "function") {
      ga("send", "event", "Produit recommandé", "Ajout au panier", handle);
    }
  });

  // document.dispatchEvent(new CustomEvent('update-reco-drawer')); --> a ajouter lors des ajouts au panier
  ("use strict");

  // Ouvrir la modal au clic
  $("body").on("click", ".button__action", function (e) {
    e.preventDefault();
    var buttonFor = $(this).attr("for");
    var selector = $(this).attr("open-selector");
    console.log(selector);
    if (selector) {
      $(selector).addClass("opened");
      $("#page__overlay").addClass("opened");
    }

    if (buttonFor == "modal" && selector) {
      $("#page__overlay").attr("for", "modal");
      if (selector === "modal-alma") {
        $("#page__overlay[for='modal']").css("z-index", "999");
      }
    } else if (buttonFor == "drawer" && selector) {
      $("#page__overlay").attr("for", "drawer");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "hidden" });
      }
    } else if (buttonFor == "drawer-cart" && selector) {
      $("#page__overlay").attr("for", "drawer");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "hidden" });
      }
      setTimeout(function () {
        $("#drawer__cart--exta-infos").addClass("opened");
      }, 350);
    } else if (buttonFor == "accordeon") {
      var isActive = false;
      if ($(this).hasClass("active")) {
        isActive = true;
      }
      if ($(this).hasClass("link--item-button")) {
        $(".link--item-button.active")
          .siblings(".accordeon__list")
          .removeClass("opened")
          .slideToggle("500");
        $(".link--item-button.active")
          .children(".plus__icon")
          .removeClass("opened");
        $(".link--item-button.active").removeClass("active");
      } else if ($(this).hasClass("sub__link--item-button")) {
        $(".sub__link--item-button.active")
          .siblings(".accordeon__list")
          .removeClass("opened")
          .slideToggle("500");
        $(".sub__link--item-button.active")
          .children(".plus__icon")
          .removeClass("opened");
        $(".sub__link--item-button.active").removeClass("active");
      }

      if (isActive == false) {
        $(this).toggleClass("active");
        $(this).children(".plus__icon").toggleClass("opened");
        $(this)
          .siblings(".accordeon__list")
          .addClass("opened")
          .slideToggle("500");
      }
    }
    if (buttonFor == "select" && selector) {
      $("#page__overlay").attr("for", "select");
    }
  });

  // Fermer la modal au clic sur la croix
  $("body").on("click", ".close", function (e) {
    e.preventDefault();
    var closeFor = $(this).attr("for");

    if ($(this).hasClass("close-alma")) {
      $("#page__overlay").attr("for", "drawer");
      $("#page__overlay[for='drawer']").css("z-index", "99");
    } else {
      $("#page__overlay").removeClass("opened");
      $("#page__overlay").attr("for", "");
    }

    if (closeFor == "modal") {
      $(".modal").removeClass("opened");
      $(".modal-loader").show();
      $(".modal-has-to-load").hide();
    } else if (closeFor == "drawer-filter") {
      $("#filter-collection-drawer").removeClass("opened");
    } else if (closeFor == "drawer") {
      $(".drawer").removeClass("opened");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "visible" });
      }
    } else if (closeFor == "select") {
      $(".select").removeClass("opened");
    }
  });

  // Clic en dehors de la'modal'
  $("#page__overlay").on("click", function (e) {
    e.preventDefault();
    var overlayFor = $(this).attr("for");

    var attribut = $(this).attr("for");
    if (attribut == "modal" && $("#modal-alma").hasClass("opened")) {
      $("#page__overlay").attr("for", "drawer");
      $("#page__overlay[for='drawer']").css("z-index", "99");
    } else {
      $(this).removeClass("opened");
      $("#page__overlay").attr("for", "");
    }

    if ($("#filter-collection-drawer").hasClass("opened")) {
      $("#filter-collection-drawer").removeClass("opened");
    }

    if (overlayFor == "modal") {
      $(".modal").removeClass("opened");
      $(".modal-loader").show();
      $(".modal-has-to-load").hide();
    } else if (overlayFor == "drawer") {
      $(".drawer").removeClass("opened");
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("html, body").css({ overflow: "visible" });
      }
    } else if (overlayFor == "select") {
      $(".select").removeClass("opened");
    }
  });

  // Ajout de la variant lors de la selection + Fermer modal
  $(".variant__select").on("click", function (e) {
    //$('#iddeclasse').attr('variant', $(this).attr("value"));
    e.preventDefault();
    $(".select").removeClass("opened");
    var closeFor = $(this).attr("for");
    $("#page__overlay").removeClass("opened");
    $("#page__overlay").attr("for", "");
  });

  $("#page__overlay--white").on("click", function (e) {
    e.preventDefault();
    $(this).removeClass("opened");
    $(".select__custom--values").hide();
    $(".select__custom--values").removeClass("opened");
  });
  ("use strict");
  ("use strict");

  // Click sur le select
  $("body").on(
    "click",
    ".select__custom--selected-value-container",
    function (e) {
      var forSelect = $(this).attr("for");
      $('.select__custom--values[for="' + forSelect + '"]').fadeToggle(50);
      $('.select__custom--values[for="' + forSelect + '"]').addClass("opened");
      $("#page__overlay--white").addClass("opened");
    },
  );

  $("body").on("click", ".select__custom--value", function (e) {
    var forSelect = $(this).attr("for");
    var value = $(this).attr("value");
    var valueText = $(this).text();
    //est ce quon a modifie un select via quick view
    var quickAdd = $(this).attr("product-grid") || "false";

    $('.select__custom--value[for="' + forSelect + '"]').removeClass(
      "is__active",
    );
    $(this).addClass("is__active");

    $('.select__custom--selected-value[name="' + forSelect + '"]').text(
      valueText,
    );
    $('.select__hidden[for="' + forSelect + '"]')
      .val(value)
      .trigger("change");
    $(".select__custom--values").hide();
    $(".select__custom--values").removeClass("opened");
    $("#page__overlay--white").removeClass("opened");
    document.dispatchEvent(
      new CustomEvent("select-changed:" + forSelect, {
        detail: { quickAdd: quickAdd },
      }),
    );
  });

  document.addEventListener(
    "select-changed:sort--by",
    function (elem) {
      console.log("Select has changed");
    },
    false,
  );

  // Sort
  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      console.log("Passe");
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $('.select__hidden[for="sort--by"]').bind("change", function () {
    Shopify.queryParams.sort_by = $(this).val();
    console.log(Shopify.queryParams);
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
  });
  ("use strict");

  var prevArrow =
    '<svg class="slick-arrow--left" viewBox="0 0 53.4 18.8"><defs><style>.cls-1{fill:#404040;}</style></defs><path class="cls-1" d="M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z"/></svg>';
  var nextArrow =
    '<svg class="slick-arrow--right" x="0px" y="0px"viewBox="0 0 53.4 18.8" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"> <style type="text/css"> .st0{fill:#404040;} </style> <path class="st0" d="M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z"/> </svg>';

  var initSlick = function initSlick() {
    $(".background-slider").slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
    });

    if (window.matchMedia("(min-width: 768px)").matches) {
      $(".carousel-product-list").slick({
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
      });
    }

    if (window.matchMedia("(max-width: 1000px)").matches) {
      $("#slider--product").slick({
        dots: true,
        customPaging: function customPaging(slider, i) {
          return '<button class="tab"></button>';
        },
        infinite: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }

    $(document).ready(function () {
      function initializeSlick() {
        const $slider = $(".multiple-items");

        if (window.innerWidth < 1200) {
          if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
              infinite: false, // Empêche la boucle infinie
              slidesToShow: 2,
              slidesToScroll: 2, // Définit un défilement par slide pour éviter de dépasser
              dots: false,
              arrows: false,
            });

            // Bloquer au dernier slide
            $slider.on("afterChange", function (event, slick, currentSlide) {
              const totalSlides = slick.slideCount;
              if (currentSlide + slick.options.slidesToShow >= totalSlides) {
                $slider.slick("slickSetOption", "slidesToScroll", 0, true); // Désactive le défilement
              } else {
                $slider.slick("slickSetOption", "slidesToScroll", 1, true); // Réactive
              }
            });
          }
        } else {
          if ($slider.hasClass("slick-initialized")) {
            $slider.slick("unslick");
          }
        }
      }

      initializeSlick();
      $(window).resize(function () {
        initializeSlick();
      });
    });

    $(document).ready(function () {
      function initializeSlick() {
        if (window.innerWidth < 1200) {
          if (!$(".cart-carousel").hasClass("slick-initialized")) {
            $(".cart-carousel").slick({
              infinite: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false,
              arrows: false,
            });
          }
        } else {
          if ($(".cart-carousel").hasClass("slick-initialized")) {
            $(".cart-carousel").slick("unslick");
          }
        }
      }

      initializeSlick();
      $(window).resize(function () {
        initializeSlick();
      });
    });

    $(".blog-slider").slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $("#instagram-feed").slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      autoplay: true,
    });

    $(".slider-two-pieces").slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $(".slider-cart-drawer").slick({
      dots: true,
      customPaging: function customPaging(slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
    });

    $(".reassurance-product--container").slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            autoplay: true,
          },
        },
      ],
    });

    $("#bandeau--footer-slider").slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            autoplay: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
            autoplay: true,
          },
        },
      ],
    });
  };

  initSlick();

  document.addEventListener(
    "theme-editor--slick",
    function (e) {
      $(".background-slider").filter(".slick-initialized").slick("unslick");
      $(".carousel-product-list").filter(".slick-initialized").slick("unslick");
      $(".blog-slider").filter(".slick-initialized").slick("unslick");
      $("#instagram-feed").filter(".slick-initialized").slick("unslick");
      $("#bandeau--footer-slider")
        .filter(".slick-initialized")
        .slick("unslick");

      initSlick();
    },
    false,
  );
  ("use strict");

  //footer
  $(window).on("resize", function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("#sidebar-accordion-footer .extended-submenu").hide();
    }
  });

  // Gestion des boutons
  $(".button__with__loading").on("click", function () {
    $(this).children(".button--text").hide();
    $(this).children(".button--loading").css("display", "flex");
  });

  // Si go back --> on remet les boutons en mode texte
  window.addEventListener("pageshow", function (event) {
    var historyTraversal =
      event.persisted ||
      (typeof window.performance != "undefined" &&
        window.performance.navigation.type === 2);
    if (historyTraversal) {
      $(".button__with__loading").children(".button--text").show();
      $(".button__with__loading")
        .children(".button--loading")
        .css("display", "none");
    }
  });

  $(".form--to-validate .form-field").on("invalid", function () {
    $(".form--to-validate .button--text").show();
    $(".form--to-validate .button--loading").css("display", "none");
  });

  function deferSrcImages(className) {
    var imgDefer = document.getElementsByClassName(className);
    for (var i = 0; i < imgDefer.length; i++) {
      if (imgDefer[i].getAttribute("defer-src")) {
        imgDefer[i].setAttribute("src", imgDefer[i].getAttribute("defer-src"));
      }
    }
  }

  function deferSrcPoster(className) {
    var imgDefer = document.getElementsByClassName(className);
    for (var i = 0; i < imgDefer.length; i++) {
      if (imgDefer[i].getAttribute("defer-poster")) {
        imgDefer[i].setAttribute(
          "poster",
          imgDefer[i].getAttribute("defer-poster"),
        );
      }
    }
  }

  function deferSrcsetImages(className) {
    var imgDefer = document.getElementsByClassName(className);
    for (var i = 0; i < imgDefer.length; i++) {
      if (imgDefer[i].getAttribute("defer-srcset")) {
        imgDefer[i].setAttribute(
          "srcset",
          imgDefer[i].getAttribute("defer-srcset"),
        );
      }
    }
  }

  window.onload = function () {
    document.dispatchEvent(new CustomEvent("update-reco-drawer"));

    deferSrcsetImages("source--product");
    setTimeout(function () {
      deferSrcImages("defer--product");
    }, 200);
    if (window.matchMedia("(max-width: 767px)").matches) {
    }

    // Sur mobile, on rafraichit la hauteur des drawers au chargement
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer").css(
        "height",
        window.innerHeight,
      );
      $("#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer").css(
        "max-height",
        window.innerHeight,
      );
    }
  };

  // Gestion de la hauteur des drawers au scroll
  $(document).on("scroll", function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer").css(
        "height",
        window.innerHeight,
      );
      $("#cart__drawer, #drawer__cart--exta-infos, #navigation__drawer").css(
        "max-height",
        window.innerHeight,
      );
    }
  });

  // Bloc SEO
  $("#show").click(function () {
    $(".max__height--seo").css("max-height", "1000px");
    $(this).hide();
    $("#hide").show();
  });
  $("#hide").click(function () {
    $(".max__height--seo").css("max-height", "80px");
    $(this).hide();
    $("#show").show();
  });

  // Bloc image video home
  if (window.matchMedia("(max-width: 767px)").matches) {
    var height = $(".text-image-video-home").innerHeight();
    console.log(height);
    $(".height-mobile-button").css("height", height);
  }
  ("use strict");

  $("#go-top").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500,
    );
  });

  if ($(document).scrollTop() > 20) {
    $("#go-top").show();
  } else {
    $("#go-top").hide();
  }

  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      $("#go-top").show();
    } else {
      $("#go-top").hide();
    }
  });
  ("use strict");

  var displayPrice = function displayPrice(price) {
    return price / 100 + "€";
  };
  ("use strict");

  $(".newsletter-form").submit(function (e) {
    e.preventDefault();
    if ($("#checkbox--newsletter").hasClass("checked")) {
      $(".checkbox--email").hide();
      var index = $(this).attr("form-index");
      var email = $('.email--newsletter[form-index="' + index + '"]')
        .val()
        .toLowerCase();
      var fields = "$source,$email,$consent,$lastName,$firstName,$date";

      var formData = {
        email: email,
        g: $('.list--newsletter[form-index="' + index + '"]').val(), // liste klaviyo
        $consent: "email",
        $source: $('.newsletter-form[form-index="' + index + '"]').attr(
          "source",
        ),
        $lastName: $(
          '#newsletter--shop-last-name[form-index="' + index + '"]',
        ).val(),
        $firstName: $(
          '#newsletter--shop-first-name[form-index="' + index + '"]',
        ).val(),
        $date: $('#newsletter--shop-date[form-index="' + index + '"]').val(),
        $fields: fields,
      };

      $.ajax({
        type: "POST",
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        data: formData,
        dataType: "json",
        success: function success(response) {
          if (response.errors && response.errors.length > 0) {
            $(".newsletter-form .error--email").show();
            _learnq.push([
              "identify",
              {
                $email: email,
              },
            ]);
          } else {
            $(".newsletter-form .success--email").show();
          }
        },
        error: function error(_error) {
          $(".newsletter-form .error--email").show();
        },
      });
    } else {
      $(".checkbox--email").show();
    }
  });

  $(".checkbox-newsletter").on("click", function () {
    if ($(this).children("#checkbox--newsletter").hasClass("checked")) {
      $(this).children("#checkbox--newsletter").removeClass("checked");
    } else {
      $(this).children("#checkbox--newsletter").addClass("checked");
    }
  });
  ("use strict");

  $(".faq__q__and__a").on("click", function () {
    $(".arrow-bottom").attr("arrow-open", "false");
    var $question = $(this).children(".faq__question");
    $(".plus__icon").removeClass("opened");
    $question.children(".plus__icon").toggleClass("opened");
    if ($question.next().attr("aria-hidden") == "false") {
      $question.next().slideToggle(200).attr("aria-hidden", "true");
      $(this).find("span").attr("arrow-open", "false");
      $(".plus__icon").removeClass("opened");
    } else {
      $(".faq__q__and__a")
        .find('.faq__answer[aria-hidden="false"]')
        .not($question)
        .slideToggle(200)
        .attr("aria-hidden", "true");
      $question.next().slideToggle(200).attr("aria-hidden", "false");
      $(this).find("span").attr("arrow-open", "true");
    }
  });

  $(".question").on("click", function () {
    $(".arrow-bottom").attr("arrow-open", "false");
    if ($(this).next().attr("aria-hidden") == "false") {
      $(this).next().slideToggle(200).attr("aria-hidden", "true");
      $(this).find("span").attr("arrow-open", "false");
    } else {
      $(".faq--container")
        .find('.faq__answer[aria-hidden="false"]')
        .not(this)
        .slideToggle(200)
        .attr("aria-hidden", "true");
      $(this).next().slideToggle(200).attr("aria-hidden", "false");
      $(this).find("span").attr("arrow-open", "true");
    }
  });

  $(".anchor__container").on("click", function () {
    var number = $(this).attr("data-separator");
    $("html, body").animate(
      {
        scrollTop: $(number).offset().top - 70,
      },
      500,
    );
  });
  ("use strict");

  $("#play").click(function () {
    if ($("#icon__play").is(":visible")) {
      $("#icon__play").hide();
      $("#icon__pause").show();
      var x = document.getElementById("myAudio");
      x.play();
    } else {
      $("#icon__pause").hide();
      $("#icon__play").show();
      var x = document.getElementById("myAudio");
      x.pause();
    }
  });
  ("use strict");

  $("#close-article-page").on("click touchend", function () {
    $("#article-page-overlay").hide();
  });
  $(document).mouseup(function (e) {
    var container = $("#article-page");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $("#article-page-overlay").hide();
    }
  });
  $(".article").on("click touchend", function () {
    var background_url = "https:" + $(this).attr("background-img");
    $("#click-contain img").attr("src", background_url);
    $("#article-page-overlay").show().css("display", "flex");
  });
  ("use strict");

  var numberChosen = 0;
  var productChosen = function productChosen() {
    var numberProduct = 0;
    $(".wishlist-product--container").each(function () {
      if ($(this).hasClass("is-chosen")) {
        numberProduct = numberProduct += 1;
        var title = $(this).attr("title");
        var price = $(this).attr("price");
        var url = $(this).attr("url");
        var id = $(this).attr("product-id");
        $(this)
          .children(".numero")
          .text("N\xB0" + numberProduct);
        var image = $(this).find(".product__item__image").attr("src");
        $(".choice-wishlist.choice-" + numberProduct).html(
          '<img class="image-choice" title="' +
            title +
            '" url="' +
            url +
            '" price="' +
            price +
            '" id="' +
            id +
            '" src="' +
            image +
            '" alt="">',
        );
        $(this).find(".tag-select--container").addClass("select-product");
        $(this)
          .find(".tag-select--container")
          .children(".text-tag-select")
          .text(window.general.selected);
      }
    });
  };

  $(".wishlist-product--container ").on("click", function () {
    var productId = $(this).attr("product-id");
    if ($(this).hasClass("is-chosen")) {
      $(this).removeClass("is-chosen");
      $(this).children(".numero").text("");
      numberChosen = numberChosen -= 1;
      $(this).find(".tag-select--container").removeClass("select-product");
      $(this)
        .find(".tag-select--container")
        .children(".text-tag-select")
        .text("" + window.general.selectWord);
      $(".image-choice").remove();
      productChosen();
    } else {
      if (numberChosen >= 4) {
      } else {
        $(this).addClass("is-chosen");
        numberChosen = numberChosen += 1;
        productChosen();
      }
    }
  });

  $(".button-wishlist-validate").on("click", function () {
    $(".email-message").hide();
    $(".valid-email").hide();
    $(".different-email").hide();
    $(".condition-message").hide();
    $(".error-message").hide();
    $(".products-message").hide();
    $(".prenom-message").hide();
  });

  $("body").on("click", ".go-back-wishlist", function () {
    $("#page__overlay").click();
    $("#modal-wishlist").removeClass("opened");
  });

  $(".checkbox-wishlist--container").on("click", function () {
    $(".checkbox-wishlist").toggleClass("active");
  });

  $(".form-wishlist").submit(function (e) {
    e.preventDefault();
    var input1 = $("#wishlist1").val();
    var input2 = $("#wishlist2").val();
    var input3 = $("#wishlist3").val();
    var prenom = $("#prenom").val();

    var matchValidationConditions = true;

    var verifyEmails = function verifyEmails() {
      $(".email-message").hide();
      $(".valid-email").hide();
      $(".different-email").hide();
      $(".condition-message").hide();
      $(".error-message").hide();
      $(".products-message").hide();
      $(".prenom-message").hide();

      if (
        !$(".choice-1 .image-choice").attr("id") ||
        !$(".choice-2 .image-choice").attr("id") ||
        !$(".choice-3 .image-choice").attr("id") ||
        !$(".choice-4 .image-choice").attr("id")
      ) {
        $(".products-message").show();
        matchValidationConditions = false;
      } else if (!prenom) {
        $(".prenom-message").show();
        matchValidationConditions = false;
      } else if (!input1 || !input2 || !input3) {
        $(".email-message").show();
        matchValidationConditions = false;
      } else if (
        !input1.match(/^(.+)@(.+)\.(.+)$/) ||
        !input2.match(/^(.+)@(.+)\.(.+)$/) ||
        !input3.match(/^(.+)@(.+)\.(.+)$/)
      ) {
        $(".valid-email").show();
        matchValidationConditions = false;
      } else if (input1 == input2 || input1 == input3 || input2 == input3) {
        $(".different-email").show();
        matchValidationConditions = false;
      } else if (
        !$(".checkbox-wishlist--container .checkbox-wishlist").hasClass(
          "active",
        )
      ) {
        $(".condition-message").show();
        matchValidationConditions = false;
      }
    };

    verifyEmails();

    if (matchValidationConditions) {
      var item = {
        prenom: prenom,
        emailParticipante: input1,
        emailInvitee1: input2,
        emailInvitee2: input3,
        productId1: $(".choice-1 .image-choice").attr("id"),
        productTitle1: $(".choice-1 .image-choice").attr("title"),
        productUrl1: $(".choice-1 .image-choice").attr("url"),
        productPrice1: $(".choice-1 .image-choice").attr("price"),
        productImage1: $(".choice-1 .image-choice").attr("src"),
        productId2: $(".choice-2 .image-choice").attr("id"),
        productTitle2: $(".choice-2 .image-choice").attr("title"),
        productUrl2: $(".choice-2 .image-choice").attr("url"),
        productPrice2: $(".choice-2 .image-choice").attr("price"),
        productImage2: $(".choice-2 .image-choice").attr("src"),
        productId3: $(".choice-3 .image-choice").attr("id"),
        productTitle3: $(".choice-3 .image-choice").attr("title"),
        productUrl3: $(".choice-3 .image-choice").attr("url"),
        productPrice3: $(".choice-3 .image-choice").attr("price"),
        productImage3: $(".choice-3 .image-choice").attr("src"),
        productId4: $(".choice-4 .image-choice").attr("id"),
        productTitle4: $(".choice-4 .image-choice").attr("title"),
        productUrl4: $(".choice-4 .image-choice").attr("url"),
        productPrice4: $(".choice-4 .image-choice").attr("price"),
        productImage4: $(".choice-4 .image-choice").attr("src"),
      };

      $.ajax({
        type: "POST",
        url: "https://hook.integromat.com/gwrs1of5e97fbe5im1iwwe2hx21cqdu7",
        data: item,
        success: function success(response) {
          $("#modal-wishlist")
            .html(
              '\n        <span class="close go-back-wishlist"></span>\n        <div class="flex fd--column">\n          <p class="h2--title yellow-wishlist text__uppercase" style="margin-top: 60px;margin-bottom: 40px;">' +
                window.general.thank_you +
                ' !</p>\n          <p class="body--text  primary__color text__center">' +
                window.general.wishlist_has_been_send +
                "</p>\n        </div>  \n       ",
            )
            .addClass("small-modal");
        },
        error: function error(response) {
          $(".error-message").show();
        },
      });
    }
  });
  ("use strict");

  var taille;
  var tailleHaut;
  var tailleBonnet;
  var tailleTourPoitrine;
  var tailleBas;
  var tailleUnePiece;

  function calculate() {
    taille = $("#taille").val();
    tailleBas = $("#tailleBas").val();
    tailleBonnet = $("#tailleBonnet").val();
    tailleTourPoitrine = $("#tailleTourPoitrine").val();

    // Calcule du maillot une pièce
    if (taille === "1") {
      if (tailleBas === "34") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "34";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "36";
        }
      } else if (tailleBas === "36") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "36";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "38";
        }
      } else if (tailleBas === "38") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "38";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "40";
        }
      } else if (tailleBas === "40") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D"
        ) {
          tailleUnePiece = "40";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "42";
        }
      } else if (tailleBas === "42") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D"
        ) {
          tailleUnePiece = "42";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "44";
        }
      } else if (tailleBas === "44") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D" ||
          tailleBonnet === "E"
        ) {
          tailleUnePiece = "44";
        }
      }
    } else if (taille === "2") {
      if (tailleBas === "34") {
        if (tailleBonnet === "A" || tailleBonnet === "B") {
          tailleUnePiece = "34";
        } else if (tailleBonnet === "C" || tailleBonnet === "D") {
          tailleUnePiece = "36";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "38";
        }
      } else if (tailleBas === "36") {
        if (tailleBonnet === "A" || tailleBonnet === "B") {
          tailleUnePiece = "36";
        } else if (
          tailleBonnet === "C" ||
          tailleBonnet === "D" ||
          tailleBonnet === "E"
        ) {
          tailleUnePiece = "38";
        }
      } else if (tailleBas === "38") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "38";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "40";
        }
      } else if (tailleBas === "40") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "40";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "42";
        }
      } else if (tailleBas === "42") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "42";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "44";
        }
      } else if (tailleBas === "44") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D"
        ) {
          tailleUnePiece = "44";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "46";
        }
      }
    } else if (taille === "3") {
      if (tailleBas === "34") {
        if (tailleBonnet === "A" || tailleBonnet === "B") {
          tailleUnePiece = "34";
        } else if (tailleBonnet === "C" || tailleBonnet === "D") {
          tailleUnePiece = "36";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "38";
        }
      } else if (tailleBas === "36") {
        if (tailleBonnet === "A" || tailleBonnet === "B") {
          tailleUnePiece = "36";
        } else if (tailleBonnet === "C" || tailleBonnet === "D") {
          tailleUnePiece = "38";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "40";
        }
      } else if (tailleBas === "38") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "38";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "40";
        }
      } else if (tailleBas === "40") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "40";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "42";
        }
      } else if (tailleBas === "42") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "42";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "44";
        }
      } else if (tailleBas === "44") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D"
        ) {
          tailleUnePiece = "44";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "46";
        }
      }
    } else if (taille === "4") {
      if (tailleBas === "34") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "36";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "38";
        }
      } else if (tailleBas === "36") {
        if (tailleBonnet === "A" || tailleBonnet === "B") {
          tailleUnePiece = "36";
        } else if (tailleBonnet === "C" || tailleBonnet === "D") {
          tailleUnePiece = "38";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "40";
        }
      } else if (tailleBas === "38") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "38";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "40";
        }
      } else if (tailleBas === "40") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "40";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "42";
        }
      } else if (tailleBas === "42") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "42";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "44";
        }
      } else if (tailleBas === "44") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D"
        ) {
          tailleUnePiece = "44";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "46";
        }
      }
    } else if (taille === "5") {
      if (tailleBas === "34") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "36";
        } else if (tailleBonnet === "D") {
          tailleUnePiece = "38";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "40";
        }
      } else if (tailleBas === "36") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "38";
        } else if (tailleBonnet === "D") {
          tailleUnePiece = "40";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "42";
        }
      } else if (tailleBas === "38") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C"
        ) {
          tailleUnePiece = "40";
        } else if (tailleBonnet === "D" || tailleBonnet === "E") {
          tailleUnePiece = "42";
        }
      } else if (tailleBas === "40") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D"
        ) {
          tailleUnePiece = "42";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "44";
        }
      } else if (tailleBas === "42") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D" ||
          tailleBonnet === "E"
        ) {
          tailleUnePiece = "44";
        }
      } else if (tailleBas === "44") {
        if (
          tailleBonnet === "A" ||
          tailleBonnet === "B" ||
          tailleBonnet === "C" ||
          tailleBonnet === "D"
        ) {
          tailleUnePiece = "44";
        } else if (tailleBonnet === "E") {
          tailleUnePiece = "46";
        }
      }
    }

    if (tailleTourPoitrine === "80") {
      if (tailleBonnet === "A" || tailleBonnet === "B") {
        tailleHaut = "34";
      } else if (tailleBonnet === "C") {
        tailleHaut = "36";
      } else if (tailleBonnet === "D") {
        tailleHaut = "38";
      } else if (tailleBonnet === "E") {
        tailleHaut = "40";
      }
    } else if (tailleTourPoitrine === "85") {
      if (tailleBonnet === "A" || tailleBonnet === "B") {
        tailleHaut = "36";
      } else if (tailleBonnet === "C") {
        tailleHaut = "38";
      } else if (tailleBonnet === "D") {
        tailleHaut = "40";
      } else if (tailleBonnet === "E") {
        tailleHaut = "42";
      }
    } else if (tailleTourPoitrine === "90") {
      if (tailleBonnet === "A") {
        tailleHaut = "36";
      } else if (tailleBonnet === "B") {
        tailleHaut = "38";
      } else if (tailleBonnet === "C") {
        tailleHaut = "40";
      } else if (tailleBonnet === "D") {
        tailleHaut = "42";
      } else if (tailleBonnet === "E") {
        tailleHaut = "44";
      }
    } else if (tailleTourPoitrine === "95") {
      if (tailleBonnet === "A" || tailleBonnet === "B") {
        tailleHaut = "40";
      } else if (tailleBonnet === "C") {
        tailleHaut = "42";
      } else if (tailleBonnet === "D" || tailleBonnet === "E") {
        tailleHaut = "44";
      }
    } else if (tailleTourPoitrine === "100") {
      if (tailleBonnet === "A" || tailleBonnet === "B") {
        tailleHaut = "42";
      } else if (tailleBonnet === "C" || tailleBonnet === "D") {
        tailleHaut = "44";
      } else if (tailleBonnet === "E") {
        tailleHaut = "46";
      }
    }

    $("#result_tailleHaut").text(tailleHaut);
    $("#result_tailleBas").text(tailleBas);
    $("#result_tailleUnePiece").text(tailleUnePiece);

    if (tailleHaut && tailleBas && tailleUnePiece) {
      $(".form-size").hide();
      $(".form-result").show();

      var CookieDate = new Date();
      CookieDate.setMonth(CookieDate.getMonth() + 12);
      document.cookie = "size=yes; expires=" + CookieDate.toGMTString();
      document.cookie =
        "sizeHaut=" + tailleHaut + "; expires=" + CookieDate.toGMTString();
      document.cookie =
        "sizeBas=" + tailleBas + "; expires=" + CookieDate.toGMTString();
      document.cookie =
        "sizeOneSize=" +
        tailleUnePiece +
        "; expires=" +
        CookieDate.toGMTString();
    }
  }

  $(".button-size-calcul").on("click", function () {
    calculate();
  });

  function getValueCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  var productGuideSize = {};
  if ($("[product-details]").html()) {
    productGuideSize = JSON.parse($("[product-details]").html());
  }

  if (getCookie("size") === "yes") {
    $(".form-size").hide();
    $(".form-result").show();
    var sizeHaut = getValueCookie("sizeHaut");
    var sizeBas = getValueCookie("sizeBas");
    var sizeOne = getValueCookie("sizeOneSize");
    $("#result_tailleHaut").text(sizeHaut);
    $("#result_tailleBas").text(sizeBas);
    $("#result_tailleUnePiece").text(sizeOne);

    if (productGuideSize.productBalise === "UNE PIÈCE") {
      setTimeout(function () {
        $('.bulle__custom--value[value="' + sizeOne + '"]').click();
      }, 100);
    } else if (productGuideSize.productBalise === "BAS") {
      setTimeout(function () {
        $('.bulle__custom--value[value="' + sizeBas + '"]').click();
      }, 100);
    } else if (productGuideSize.productBalise === "HAUT") {
      setTimeout(function () {
        $('.bulle__custom--value[value="' + sizeHaut + '"]').click();
      }, 100);
    }
  }

  $(".button-reinitialize-size").on("click", function () {
    var CookieDate = new Date();
    document.cookie = "size=yes; expires=" + CookieDate.toGMTString();
    document.cookie =
      "sizeHaut=" + tailleHaut + "; expires=" + CookieDate.toGMTString();
    document.cookie =
      "sizeBas=" + tailleBas + "; expires=" + CookieDate.toGMTString();
    document.cookie =
      "sizeOneSize=" + tailleUnePiece + "; expires=" + CookieDate.toGMTString();
    $(".form-size").show();
    $(".form-result").hide();
  });

  $(".button-guide-add-cart").on("click", function () {
    var sizeHaut = tailleHaut;
    var sizeBas = tailleBas;
    var sizeOne = tailleUnePiece;
    var productId = $(this).attr("product-id");

    if (productGuideSize.productBalise === "UNE PIÈCE") {
      setTimeout(function () {
        $('.bulle__custom--value[value="' + sizeOne + '"]').click();
      }, 100);
    } else if (productGuideSize.productBalise === "BAS") {
      setTimeout(function () {
        $('.bulle__custom--value[value="' + sizeBas + '"]').click();
      }, 100);
    } else if (productGuideSize.productBalise === "HAUT") {
      setTimeout(function () {
        $('.bulle__custom--value[value="' + sizeHaut + '"]').click();
      }, 100);
    }

    setTimeout(function () {
      $(".add__to__cart[product-id=" + productId + "]").click();
      $("#modal-taille, #page__overlay").removeClass("opened");
      $("#page__overlay").attr("for", "");
    }, 200);
  });
  ("use strict");

  var container = [];

  $("#slider--product")
    .find(".carousel-cell")
    .each(function () {
      var $link = $(this).find(".product__image"),
        item = {
          src: $link.attr("src"),
          w: $link.attr("width"),
          h: $link.attr("height"),
        };
      container.push(item);
    });

  var gallery = "";
  // Define click event on gallery item
  $("body").on("click", "#slider--product .carousel-cell", function (event) {
    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $(".pswp")[0],
      options = {
        index: $(this).index(),
      };
    console.log($pswp);
    //console.log($(this))

    // Initialize PhotoSwipe
    gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
    gallery.init();

    if (window.matchMedia("(max-width: 1000px)").matches) {
      $("#slider--product")
        .find(".carousel-cell")
        .each(function () {
          var id = $(this).attr("id");
          if (id !== undefined) {
            console.log(id);
            console.log($(this));
            $(this)
              .find(".product__image")
              .clone()
              .appendTo(".pswp__thumbnail");
          }
        });
    } else {
      $("#slider--product img").clone().appendTo(".pswp__thumbnail");
    }

    $(".button-pswp--container, .pswp__thumbnail").addClass("opened");

    $(".pswp__thumbnail img").eq(gallery.getCurrentIndex()).addClass("active");

    gallery.listen("close", function () {
      $(".pswp__thumbnail img").remove();
      $(".button-pswp--container, .pswp__thumbnail").removeClass("opened");
    });
  });

  $("body").on("click", ".pswp__thumbnail img", function (e) {
    $(".pswp__thumbnail img").removeClass("active");
    $(this).addClass("active");

    var number = $(".pswp__thumbnail img").index($(this));
    console.log(number);
    console.log(gallery);
    gallery.goTo(number);

    $(".button-zoom-pswp").children(".see-more").removeClass("opened");
  });

  $("body").on("click", ".button-close-pswp", function () {
    gallery.close();
  });

  $("body").on("click", ".button-zoom-pswp", function () {
    gallery.toggleDesktopZoom();
    if ($(".pswp").hasClass("pswp--zoomed-in")) {
      $(".button-zoom-pswp").children(".see-more").addClass("opened");
    } else {
      $(".button-zoom-pswp").children(".see-more").removeClass("opened");
    }
  });

  $("body").on("click", ".pswp__img", function () {
    if ($(".pswp").hasClass("pswp--zoomed-in")) {
      $(".button-zoom-pswp").children(".see-more").addClass("opened");
    } else {
      $(".button-zoom-pswp").children(".see-more").removeClass("opened");
    }
  });
  ("use strict");

  $("ul.sidebar-accordion")
    .find("li.extend")
    .click(function () {
      $("li.extend.active").not($(this)).toggleClass("active");
      //Expand or collapse this panel
      $(this).next().slideToggle("fast");
      $(this).toggleClass("active");
      //Hide the other panels
      $("ul.extended-submenu").not($(this).next()).slideUp("fast");
    });

  $("#moreDetails").on("click", function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("html, body").animate(
        {
          scrollTop:
            $(".ProductDescription--mobile-container").offset().top - 140,
        },
        600,
      );
    } else {
      $("html, body").animate(
        {
          scrollTop: $(".ProductDescription").offset().top - 200,
        },
        600,
      );
    }
  });

  $(".tabs").each(function () {
    var active,
      content,
      links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });
    $(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        active = $(this);
        content = $($(this).attr("href"));
        active.addClass("active");
        content.show();
        return false;
      });
  });

  $("#details__anchor").on("click", function () {
    var id = $(this).attr("href");

    $("html, body").animate(
      {
        scrollTop: $(id).offset().top - 150,
      },
      500,
    );
  });
  /*$('#slider--product').slick({
  dots: false,
  infinite: true,
  arrows: false,
  waitForAnimate: false,
  responsive: [
  {
    breakpoint: 767,
    settings: {
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow
    }
  }]
});

$('#slider--product').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('#slider__nav--product .carousel-cell').removeClass('is-nav-selected');
  $(`#slider__nav--product .carousel-cell[thumb-index="${nextSlide}"]`).addClass('is-nav-selected');
});

$('#slider__nav--product .carousel-cell').on('click', function() {
  var index = $(this).attr('thumb-index');
  $('#slider__nav--product .carousel-cell').removeClass('is-nav-selected');
  $(this).addClass('is-nav-selected');
  $('#slider--product').slick('slickGoTo', index);
})*/
  ("use strict");
  ("use strict");

  var productDetails = {};
  if ($("[product-details]").html()) {
    productDetails = JSON.parse($("[product-details]").html());
  }

  $(".quantity__change--selector-product").on("click", function () {
    var type = $(this).attr("type");
    var currentQty = parseInt(
      $(".product__qty--container .quantity__current").val(),
    );

    if (type == "minus") {
      if (currentQty != 0) {
        $(".product__qty--container .quantity__current").val(currentQty - 1);
      }
    } else {
      $(".product__qty--container .quantity__current").val(currentQty + 1);
    }
  });

  document.addEventListener(
    "select-changed:product__option--1",
    function (event) {
      if (event.detail.quickAdd == "true") {
        onOptionChangedQuickAdd();
      } else {
        onOptionChanged();
      }
    },
    false,
  );
  document.addEventListener(
    "select-changed:product__option--2",
    function (event) {
      if (event.detail.quickAdd == "true") {
        onOptionChangedQuickAdd();
      } else {
        onOptionChanged();
      }
    },
    false,
  );
  document.addEventListener(
    "select-changed:product__option--3",
    function (event) {
      if (event.detail.quickAdd == "true") {
        onOptionChangedQuickAdd();
      } else {
        onOptionChanged();
      }
    },
    false,
  );

  // Change variant for bulles
  $(".bulle__custom--value").on("click", function () {
    var value = $(this).text();
    var option = $(this).attr("for");

    $('.select__custom--selected-value[for="' + option + '"]').text(value);
    $('.bulle__custom--value[for="' + option + '"]').removeClass("is__active");
    $(this).addClass("is__active");

    document.dispatchEvent(
      new CustomEvent("select-changed:" + option, {
        detail: { quickAdd: "false" },
      }),
    );
  });

  function updateProductButton(variant, productId) {
    var price = parseFloat(variant.price.replace("€", ""));
    var compareAtPrice = parseFloat(variant.compareAtPrice.replace("€", ""));
    if (variant.available == 0) {
      $('.add__to__cart[product-id="' + productId + '"]').html(
        '<span class="button--text white">\n          ' +
          window.general.soldOut +
          "\n        </span>",
      );
      $('.add__to__cart[product-id="' + productId + '"]').attr(
        "id",
        "BIS_trigger",
      );
      $('.add__to__cart[product-id="' + productId + '"]').attr(
        "variant-available",
        false,
      );
      $('.add__to__cart[product-id="' + productId + '"]').attr(
        "data-variant-id",
        variant.id,
      );
    } else {
      $('.add__to__cart[product-id="' + productId + '"]').attr("id", "");
      $('.add__to__cart[product-id="' + productId + '"]').attr(
        "variant-available",
        true,
      );
      if (compareAtPrice > price) {
        $('.add__to__cart[product-id="' + productId + '"]').html(
          window.general.addToCart,
        );
      } else {
        $('.add__to__cart[product-id="' + productId + '"]').html(
          window.general.addToCart,
        );
      }
    }
  }

  function onOptionChanged() {
    var productOptions = [];

    for (var i = 1; i <= 3; i++) {
      productOptions[i - 1] =
        $(
          '.select__custom--selected-value[product-id="' +
            productDetails.productId +
            '"][name="product__option--' +
            i +
            '"]',
        )
          .text()
          .trim() || "";
    }
    if (productDetails && productDetails.variants.length > 1) {
      productDetails.variants.forEach(function (variant) {
        //console.log(variant)
        if (
          variant.option1 == productOptions[0] &&
          variant.option2 == productOptions[1] &&
          variant.option3 == productOptions[2]
        ) {
          $(".product--price").text(variant.price);
          $(".product--compare-at-price").text(variant.compareAtPrice);
          $(
            '.add__to__cart[product-id="' + productDetails.productId + '"]',
          ).attr("variant-id", variant.id);

          if (variant.availableQty < 10 && variant.availableQty > 0) {
            $(".product__inventory").text(window.general.few_pieces_left);
          } else {
            $(".product__inventory").text("");
          }

          var url =
            document.location.origin +
            document.location.pathname +
            ("?variant=" + variant.id);
          window.history.replaceState({ path: url }, "", url);
          var featuredImage = variant.imageId;

          // Change image on variant change
          var imageNumber =
            parseInt(
              $(
                '#slider--product .product__image[image-id="' +
                  featuredImage +
                  '"]',
              ).attr("slide-number"),
            ) - 1;
          if (imageNumber) {
            $("#slider--product").slick("slickGoTo", imageNumber);
          }

          updateProductButton(variant, productDetails.productId);
        }
      });
    }
  }

  $(".sidebar-accordion-description-product")
    .find("li.extend")
    .click(function (e) {
      $(this).children(".extended-submenu").slideToggle("fast");
      $(this)
        .children(".nav__des-product--title")
        .children(".plus__icon")
        .toggleClass("opened");
      $(this).toggleClass("active");
    });

  $("body").on("click", ".bulle__custom--value-two-pieces", function () {
    $(".bulle__custom--value-two-pieces").removeClass("is__active");
    $(this).addClass("is__active");
    var productId = $(this).attr("product-id");
    var variantId = $(this).attr("variant-id");
    var variantAvailable = $(this).attr("variant-available");
    $(".button-two-pieces[product-id=" + productId + "]")
      .attr("variant-id", variantId)
      .attr("variant-available", variantAvailable);
    if (variantAvailable == "false") {
      $(".button-two-pieces[product-id=" + productId + "]").text(
        window.general.soldOutOneWord,
      );
    } else {
      $(".button-two-pieces[product-id=" + productId + "]").text(
        window.general.addToCart,
      );
    }
  });
  ("use strict");

  var announcementDetails = {};
  if ($("[announcement-details]").html()) {
    announcementDetails = JSON.parse($("[announcement-details]").html());
  }

  var text_ecran = announcementDetails.text_ecran;
  var text_mobile = announcementDetails.text_mobile;
  var lien_ecran = announcementDetails.lien_ecran;
  var lien_mobile = announcementDetails.lien_mobile;
  var counter = 1;
  var elem = $("#annonce");

  if (window.matchMedia("(min-width: 767px)").matches) {
    var change = function change() {
      if (text_ecran && text_ecran.length > 1) {
        elem.fadeOut(function () {
          elem.html(text_ecran[counter]);
          if (lien_ecran[counter] != "unlink") {
            elem.attr("href", lien_ecran[counter]);
          } else {
            elem.removeAttr("href");
          }
          counter++;
          if (counter >= text_ecran.length) {
            counter = 0;
          }
          elem.fadeIn();
        });
      }
    };

    if (lien_ecran && lien_ecran[0] != "unlink") {
      elem.attr("href", lien_ecran[0]);
    } else {
      elem.removeAttr("href");
    }
    setInterval(change, 6000);
  } else {
    var _change = function _change() {
      if (text_mobile && text_mobile.length > 1) {
        elem.fadeOut(function () {
          elem.html(text_mobile[counter]);
          if (lien_mobile[counter] != "unlink") {
            elem.attr("href", lien_mobile[counter]);
          } else {
            elem.removeAttr("href");
          }
          counter++;
          if (counter >= text_mobile.length) {
            counter = 0;
          }
          elem.fadeIn();
        });
      }
    };

    if (lien_ecran && lien_mobile[0] != "unlink") {
      elem.attr("href", lien_mobile[0]);
    } else {
      elem.removeAttr("href");
    }

    text_mobile ? elem.html(text_mobile[0]) : null;
    setInterval(_change, 3000);
  }
  ("use strict");

  if (window.matchMedia("(max-width: 767px)").matches) {
    $("#sidebar-accordion-footer .plus__icon").show();
    $("#sidebar-accordion-footer")
      .find("li.extend")
      .click(function (e) {
        $(this).children(".extended-submenu").slideToggle("fast");
        $(this)
          .children(".nav__footer--title")
          .children(".plus__icon")
          .toggleClass("opened");
        $(this).toggleClass("active");
      });
  }

  $(window).on("resize", function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("#sidebar-accordion-footer .extended-submenu").hide();
    }
    if (window.matchMedia("(min-width: 768px)").matches) {
      $("#sidebar-accordion-footer .extended-submenu").show();
    }
  });
  ("use strict");

  /*var pageOverlayOpened = false;
$( ".navigation__item--link-megamenu" ).mouseenter(function() {
  if (pageOverlayOpened == false) {
    $('#page__overlay--navigation').addClass('opened');
    pageOverlayOpened = true
  }
})

$( ".navigation__item--link-megamenu" ).mouseleave(function() {
  if (pageOverlayOpened == true) {
    $('#page__overlay--navigation').removeClass('opened');
    pageOverlayOpened = false
  }
})*/

  // Gestion de la hauteur du drawer sur mobile
  // a utiliser si le drawer ne fait pas 100% de l'ecran, sinon on peut commenter
  /*if ($(document).scrollTop() > 20) {
  var navbarHeightMobile = 40;
} else {
  var navbarHeightMobile = 74;
}
$('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile) // init
$(document).on('scroll', function() {
  if ($(document).scrollTop() > 20) {
    var navbarHeightMobile = 40;
  } else {
    var navbarHeightMobile = 74;
  }
  $('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile)
})*/

  $(".parent").on("click", function () {
    var menu = $(this).attr("for");
    $(".parent.is-active").removeClass("is-active");
    $('.parent[for="' + menu + '"]').addClass("is-active");

    /*var CookieDate = new Date;
  CookieDate.setMonth(CookieDate.getMonth() + 12);
  document.cookie = "favorite-menu=" + menu + "; expires=" + CookieDate.toGMTString() + "; path=/";*/
    $(".menu--container.is-active").hide();
    $(".menu--container").removeClass("is-active");
    $('.menu--container[for="' + menu + '"]').fadeIn(400);
    $('.menu--container[for="' + menu + '"]').addClass("is-active");
  });

  // Select menu
  var initMenu = getCookie("favorite-menu");
  if (initMenu == undefined || initMenu == "undefined") {
    $(".parent.is-active").removeClass("is-active");
    $('.parent[for="menu-2"]').addClass("is-active");
    $(".menu--container.is-active").removeClass("is-active");
    $('.menu--container[for="menu-2"]').addClass("is-active");
  }
  if (initMenu && initMenu != undefined && initMenu != "undefined") {
    $(".parent.is-active").removeClass("is-active");
    $('.parent[for="' + initMenu + '"]').addClass("is-active");
    $(".menu--container.is-active").removeClass("is-active");
    $('.menu--container[for="' + initMenu + '"]').addClass("is-active");
    $('.menu--container[for="' + initMenu + '"]').show();
  } else {
    $(".menu--container.is-active").show();
  }
  ("use strict");

  var whiteNavBar = function whiteNavBar() {
    $("#main__logo--svg").removeClass("logo--white");
    $(".link--text-style").removeClass("white").addClass("grey");
    $("#icon-account .icon--compte").removeClass("logo--white");
    $(".icon--anja").removeClass("logo--white");
    $("#icon-search .icon--search").removeClass("logo--white");
    $("#icon-help .icon--help").removeClass("logo--white");
    $("#icon-search-mobile .icon--search").removeClass("logo--white");
    $(".icon--nav").removeClass("logo--white");
    $(".icon--cart").removeClass("logo--white");
    $(".icon--account").removeClass("logo--white");
    $("#icon-help-mobile .icon--help").removeClass("logo--white");
    $(".site-header__section--switcher").addClass("nav-black");
  };

  // var transparentNavbar = function transparentNavbar() {
  //   $("#main__logo--svg").addClass("logo--white");
  //   $(".link--text-style").addClass("white").removeClass("grey");
  //   $("#icon-account .icon--compte").addClass("logo--white");
  //   $(".icon--anja").addClass("logo--white");
  //   $("#icon-search .icon--search").addClass("logo--white");
  //   $("#icon-help .icon--help").addClass("logo--white");
  //   $("#icon-search-mobile .icon--search").addClass("logo--white");
  //   $(".icon--nav").addClass("logo--white");
  //   $(".icon--cart").addClass("logo--white");
  //   $(".icon--account").addClass("logo--white");
  //   $("#icon-help-mobile .icon--help").addClass("logo--white");
  //   $(".site-header__section--switcher").removeClass("nav-black");
  // };
  //
  // var handleBarChange = function handleBarChange() {
  //   if ($("#navigation--container").hasClass("fixedWhiteNav") == false) {
  //     $("#navigation--container").addClass("transparent--nav");
  //     if (window.nav.navBlack === true && window.location.pathname == "/") {
  //       if ($(document).scrollTop() < 20) {
  //         whiteNavBar();
  //       }
  //     } else {
  //       transparentNavbar();
  //     }
  //   }
  // };
  // window.location.pathname == "/" ||
  // if (window.general.headerTransparent == 1) {
  //   /*if (window.matchMedia("(min-width: 1101px)" ).matches) {*/
  //   $("#navigation--container").mouseenter(function () {
  //     $("#page__overlay--navigation").addClass("opened");
  //     if (window.nav.navBlack === true && window.location.pathname == "/") {
  //       if ($(document).scrollTop() < 20) {
  //         transparentNavbar();
  //       }
  //     }
  //   });

  // $("#navigation--container").mouseleave(function () {
  //   if (
  //     $(".search--container").hasClass("opened") ||
  //     $(".search--container").hasClass("opened-scroll") ||
  //     $(".search--container").hasClass("opened-mobile-scroll") ||
  //     $(".search--container").hasClass("opened-mobile") ||
  //     $(".search--container").hasClass("opened-mobile2")
  //   ) {
  //   } else {
  //     $("#page__overlay--navigation").removeClass("opened");
  //     if ($(document).scrollTop() < 20) {
  //       handleBarChange();
  //     }
  //   }
  // });
  // if ($(document).scrollTop() < 20) {
  //   if ($("#navigation--container").hasClass("fixedWhiteNav") == false) {
  //     $("#navigation--container").addClass("transparent--nav");
  //   }
  // } else {
  //   $("#navigation--container").removeClass("transparent--nav");
  //   $("#navigation--container").addClass("scrolled--nav");
  //   whiteNavBar();
  // }

  // $(document).on("scroll", function () {
  //   if ($(document).scrollTop() > 20) {
  //     $("#navigation--container").removeClass("transparent--nav");
  //     $("#navigation--container").addClass("scrolled--nav");
  //     whiteNavBar();
  //
  //     $("#navigation--container").mouseleave(function () {
  //       whiteNavBar();
  //     });
  //   } else {
  //     handleBarChange();
  //
  //     $("#navigation--container").removeClass("scrolled--nav");
  //     $("#navigation--container").mouseleave(function () {
  //       handleBarChange();
  //     });
  //   }
  // });
  /*}*/
  // } else {
  //   $(document).on("scroll", function () {
  //     if ($(document).scrollTop() > 20) {
  //       // Ajoute le fond blanc et le texte noir
  //       $("#navigation--container").removeClass(
  //         "transparent--nav transparent-black-text",
  //       );
  //       $("#navigation--container").addClass("scrolled-white-nav");
  //     } else {
  //       // Restaure la transparence avec texte noir en dessous de 20 pixels
  //       $("#navigation--container").removeClass("scrolled-white-nav");
  //       $("#navigation--container").addClass(
  //         "transparent--nav transparent-black-text",
  //       );
  //     }
  //   });

  // Ajoute et enlève les classes pour `mouseenter` et `mouseleave` dans le bloc `else`
  // if (window.location.pathname != "/" /* other condition */) {
  //   $("#navigation--container").mouseenter(function () {
  //     $("#page__overlay--navigation").addClass("opened");
  //     $("#navigation--container").addClass(
  //       "transparent--nav transparent-black-text",
  //     );
  //   });
  //
  //   $("#navigation--container").mouseleave(function () {
  //     if (
  //       $(".search--container").hasClass("opened") ||
  //       $(".search--container").hasClass("opened-scroll") ||
  //       $(".search--container").hasClass("opened-mobile-scroll") ||
  //       $(".search--container").hasClass("opened-mobile") ||
  //       $(".search--container").hasClass("opened-mobile2") ||
  //       $(".search--container").hasClass("opened-blog")
  //     ) {
  //       // Ne rien faire, laisser ouvert
  //     } else {
  //       $("#page__overlay--navigation").removeClass("opened");
  //       $("#navigation--container").removeClass(
  //         "transparent--nav transparent-black-text",
  //       );
  //     }
  //   });
  // }

  /*if (window.location.pathname == "/" || window.general.headerTransparent == 1) {
if (window.location.href.indexOf("product") > -1) {
  if (window.matchMedia("(min-width: 1101px)" ).matches) {

    if ($(document).scrollTop() < 20) {
      if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
        $("#navigation--container").addClass('transparent--nav');
      }
      $('#navigation--container').mouseenter(function() {
        $(this).removeClass('transparent--nav');
      })

      $('#navigation--container').mouseleave(function() {
        if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
          $("#navigation--container").addClass('transparent--nav');
        }
      })
    }


    if ($(document).scrollTop() > 20) {
      $("#navigation--container").removeClass('transparent--nav');
      $("#navigation--container").addClass('scrolled--nav');
    }

    $(document).on('scroll', function() {
      if ( $(document).scrollTop() > 20 ) {
        $("#navigation--container").removeClass('transparent--nav');
        $("#navigation--container").addClass('scrolled--nav');


      } else {
        if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
          $("#navigation--container").addClass('transparent--nav');
        }
        $("#navigation--container").removeClass('scrolled--nav');


        $('#navigation--container').mouseleave(function() {
          if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
            $("#navigation--container").addClass('transparent--nav');
          }
        })
      }
    });
  }
} else {
  if (window.matchMedia("(min-width: 1101px)" ).matches) {

    if ($(document).scrollTop() < 20) {
      if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
        $("#navigation--container").addClass('transparent--nav');
      }
      $('#navigation--container').mouseenter(function() {
        $(this).removeClass('transparent--nav');
        whiteNavBar();
      })

      $('#navigation--container').mouseleave(function() {
        handleBarChange();
      })
    } else {
      $("#navigation--container").removeClass('transparent--nav');
      $("#navigation--container").addClass('scrolled--nav');
      whiteNavBar();
    }

    $(document).on('scroll', function() {
      if ( $(document).scrollTop() > 20 ) {
        $("#navigation--container").removeClass('transparent--nav');
        $("#navigation--container").addClass('scrolled--nav');
        whiteNavBar();

        $('#navigation--container').mouseleave(function() {
          whiteNavBar();
        })

      } else {
        handleBarChange();

        $("#navigation--container").removeClass('scrolled--nav');
        $('#navigation--container').mouseleave(function() {
          handleBarChange();
        })
      }
    });
  }
}
}*/

  // Gestion de la hauteur du drawer sur mobile
  // a utiliser si le drawer ne fait pas 100% de l'ecran
  /*if ($(document).scrollTop() > 20) {
var navbarHeightMobile = 40;
} else {
var navbarHeightMobile = 74;
}
$('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile) // init
$(document).on('scroll', function() {
if ($(document).scrollTop() > 20) {
  var navbarHeightMobile = 40;
} else {
  var navbarHeightMobile = 74;
}
$('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile)
})*/

  // Gestion du scroll
  if (window.matchMedia("(max-width: 1100px)").matches) {
    if ($(document).scrollTop() > 20) {
      $("#navigation__drawer").addClass("scroll-drawer");
    } else {
      $("#navigation__drawer").removeClass("scroll-drawer");
    }
    $(document).on("scroll", function () {
      if ($(document).scrollTop() > 20) {
        $("#navigation__drawer").addClass("scroll-drawer");
      } else {
        $("#navigation__drawer").removeClass("scroll-drawer");
      }
    });
  }
  ("use strict");

  if (
    window.location.href.indexOf("blog") > -1 ||
    window.location.href.indexOf("article") > -1
  ) {
    $("#icon-search-blog, #icon-search-blog-2").on("click", function () {
      if ($(".search--container").hasClass("opened-blog")) {
        $(".search--container").removeClass("opened-blog");
        $(".searchArticle").val("");
        $(".result-search").html("");
      } else {
        $(".search--container").addClass("opened-blog");
      }
    });

    var handleCloseSearch = function handleCloseSearch() {
      $(".searchArticle").val("");
      $(".result-search").html("");
      $(".search--container").removeClass("opened-blog");
      $(".search--container").css("transform", "");
      $("#page__overlay--navigation").removeClass("opened");
    };

    $(".close--search").on("click", function () {
      handleCloseSearch();
    });

    $(document).on("click", function (e) {
      var container = $(".search--container");
      var container2 = $(".search--container-barre");
      if ($(e.target).hasClass("search--trigger")) {
      } else {
        if (
          container.hasClass("opened-blog") &&
          !container.is(e.target) &&
          container.has(e.target).length === 0
        ) {
          handleCloseSearch();
        }
      }

      if (!container2.is(e.target) && container2.has(e.target).length === 0) {
        $(".searchArticle-barre").val("");
        $(".result-search-barre").html("");
      }
    });
  } else {
    var handleSearchBar = function handleSearchBar(
      searchTriggerId,
      positionScrolledClass,
      positionClass,
      translateYScrolled,
      translateY,
    ) {
      $(searchTriggerId).on("click", function () {
        if (
          $(".search--container").hasClass(positionScrolledClass) ||
          $(".search--container").hasClass(positionClass)
        ) {
          //$('#page__overlay--navigation').removeClass('opened');
          $(".navigation__item--container").removeClass("search--opened");
          $("#navigation--container").removeClass("fixedWhiteNav");
          /*if ($(document).scrollTop() < 20) {
        $('#navigation--container').addClass('transparent--nav');
        transparentNavbar()
      }*/
          $(".search--container").removeClass(
            positionScrolledClass + " " + positionClass,
          );
          $(".search--container").css("transform", "");
          $(".searchProduct").val("");
          $(".result-search").html("");
          $(".popular_product").hide();
        } else {
          $("#page__overlay--navigation").addClass("opened");
          $(".navigation__item--container").addClass("search--opened");
          $("#navigation--container").addClass("fixedWhiteNav");
          $("#navigation--container").removeClass("transparent--nav");
          $(".popular_product").show();
          whiteNavBar();
          if ($(document).scrollTop() >= 20) {
            $(".search--container").addClass(positionScrolledClass);
          } else {
            var topPosition = translateY - $(document).scrollTop();
            $(".search--container").addClass(positionClass);
            $(
              ".search--container." +
                positionClass +
                ", .search--container." +
                positionScrolledClass,
            ).css("transform", "translateY(" + topPosition + "px)");
          }
        }
        $(".searchProduct.search--input").focus();
      });

      $(document).on("scroll", function () {
        if ($(document).scrollTop() >= 20) {
          $(
            ".search--container." +
              positionClass +
              ", .search--container." +
              positionScrolledClass,
          ).css("transform", "translateY(" + translateYScrolled + "px)");
        } else {
          var topPosition = translateY - $(document).scrollTop();
          $(
            ".search--container." +
              positionClass +
              ", .search--container." +
              positionScrolledClass,
          ).css("transform", "translateY(" + topPosition + "px)");
        }
      });
    };

    if (window.matchMedia("(max-width: 767px)").matches) {
      handleSearchBar(
        "#icon-search-mobile",
        "opened-mobile-scroll",
        "opened-mobile2",
        260,
        302,
      );
    } else if (window.matchMedia("(max-width: 1100px)").matches) {
      handleSearchBar(
        "#icon-search-mobile",
        "opened-mobile-scroll",
        "opened-mobile",
        260,
        302,
      );
    } else {
      handleSearchBar("#icon-search", "opened-scroll", "opened", 309, 351);
    }

    var handleCloseSearch = function handleCloseSearch() {
      $(".searchProduct").val("");
      $(".result-search").html("");
      $(".search--container").removeClass(
        "opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2",
      );
      $(".search--container").css("transform", "");
      $("#navigation--container").removeClass("fixedWhiteNav");
      $("#page__overlay--navigation").removeClass("opened");
      $(".navigation__item--container").removeClass("search--opened");
      if ($(document).scrollTop() < 20) {
        handleBarChange();
        $("#navigation--container").addClass("transparent--nav");
      }
    };

    $(".close--search").on("click", function () {
      handleCloseSearch();
    });

    $(document).on("click", function (e) {
      var container = $(".search--container");
      if ($(e.target).hasClass("search--trigger")) {
      } else {
        if (
          (container.hasClass("opened") ||
            container.hasClass("opened-mobile") ||
            container.hasClass("opened-scroll") ||
            container.hasClass("opened-mobile-scroll") ||
            container.hasClass("opened-scroll") ||
            container.hasClass("opened-mobile2")) &&
          !container.is(e.target) &&
          container.has(e.target).length === 0
        ) {
          handleCloseSearch();
        }
      }
    });

    $(document).on("click", ".global-search", function () {
      //var url = window.location.hostname
      var search = document.getElementsByClassName("searchProduct")[0].value;
      var redirection = "/search?type=product&q=" + search;
      window.location.replace(redirection);
      $(".search--container").removeClass("opened");
    });
  }

  $(document).on("input", ".search--input", function () {
    if ($(this).attr("search") === "barre") {
      SearchFunction("searchArticle-barre", "article", "result-search-barre");
    } else if ($(this).attr("search") === "article") {
      SearchFunction("searchArticle", "article", "result-search");
    } else if ($(this).attr("search") === "produit") {
      SearchFunction("searchProduct", "product", "result-search");
    }
  });

  var SearchFunction = function SearchFunction(
    classInput,
    typeSearch,
    classInputResult,
  ) {
    var htmlItem = function htmlItem(type, item) {
      if (type == "article") {
        return (
          "<div class='one-product'><a class='flex fd--row jc--flex-start' href=" +
          item[i].url +
          "><img class='image-product' src=" +
          item[i].image +
          "><div class='content--container flex fd--column ai--flex-start'><p class='product--title grey'>" +
          item[i].title +
          "</p></div></a></div>"
        );
      } else {
        if (item[i].compare_at_price_max == 0.0) {
          var prix = item[i].price.replace(".", ",") + "€";
        } else {
          var prix =
            item[i].price.replace(".", ",") +
            "€<span class='reduction line__through '>" +
            item[i].compare_at_price_max.replace(".", ",") +
            "€</span>";
        }
        var titre = item[i].title.split("-");
        console.log(titre);
        var titreWithout = item[i].title.replace(titre[0], "");
        return (
          " <div class='one-product'><a class='flex fd--row jc--flex-start' href=" +
          item[i].url +
          "><img class='image-product' src=" +
          item[i].image +
          "><div class='content--container flex fd--column ai--flex-start'><p class='product--title grey'><span class='product--title-black text__uppercase'>" +
          titre[0] +
          "</span>" +
          titreWithout +
          "</p><p class='price product--title grey'>" +
          prix +
          "</p></div></a></div>"
        );
      }
    };

    var emptyItem = function emptyItem(type) {
      if (type == "article") {
        return "<div class='empty'>Aucun article ne correspond à votre recherche</div>";
      } else {
        return "<div class='empty'>Aucun produit ne correspond à votre recherche</div>";
      }
    };

    var q = document.getElementsByClassName(classInput)[0].value;
    var b = "&resources[type]=" + typeSearch;
    var c = "";
    if (q == "") {
      $(".result-search").html("");
      $(".result-search-barre").html("");
    }
    if (typeSearch == "article") {
      var type = "article";
    } else {
      var type = "product";
      c = "&fields=title,product_type,tag";
      if (q == "") {
        $(".popular_product").show();
      } else {
        $(".popular_product").hide();
      }
    }
    var first;
    if (window.general.langue !== "fr") {
      first = "/" + window.general.langue + "/search/suggest.json?q=";
    } else {
      first = "/search/suggest.json?q=";
    }
    $.ajax(first + q + b + c, {
      type: "GET",
      dataType: "json",
      success: function success(response) {
        var itemsSuggestions = response.resources.results[typeSearch + "s"];
        if (itemsSuggestions.length > 0) {
          var result = "";
          for (i = 0; i < itemsSuggestions.length; i++) {
            if (
              itemsSuggestions[i].id != 6623214993579 &&
              itemsSuggestions[i].id != 6623216205995
            ) {
              result += htmlItem(type, itemsSuggestions);
            }
          }

          if (type == "product") {
            result =
              result +
              "<div class='global-search cursor--pointer'>Plus de résultats</div>";
          }
          $("." + classInputResult).html(result);
        } else {
          var emptyProduct = emptyItem(type);
          $("." + classInputResult).html(emptyProduct);
        }
      },
    });
  };
});
